import React, {
  Fragment,
  useCallback,
  useEffect,
  useReducer,
  useState,
} from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Row,
} from "react-bootstrap";
import { getAllChequeras, saveChequera } from "../../../Api/chequera";

/* ================= REDUCER ================= */
const showReducer = (state, action) => {
  switch (action.type) {
    case "SHOW_NEW":
      return { showNew: true, showEdit: false };
    case "SHOW_EDIT":
      return { showNew: false, showEdit: true };
    case "CLOSE":
      return { showNew: false, showEdit: false };
    default:
      return state;
  }
};

const OCheques = () => {
  const [listChequeras, setListChequeras] = useState([]);
  const [selected, setSelected] = useState(null);

  const [modal, dispatchModal] = useReducer(showReducer, {
    showNew: false,
    showEdit: false,
  });

  /* ===== CARGAR CHEQUERAS ===== */
  const onLoadChequeras = useCallback(async () => {
    try {
      const res = await getAllChequeras();
      setListChequeras(res);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    onLoadChequeras();
  }, [onLoadChequeras]);

  /* ===== NUEVO ===== */
  const onAgregar = () => {
    setSelected({
      nombre: "",
      numeroInicio: "",
      numeroFinal: "",
      banco: "",
      cuenta: "",
      estaActivo: 1, // 🔥 alineado al backend
    });
    dispatchModal({ type: "SHOW_NEW" });
  };

  /* ===== EDITAR ===== */
  const onEditar = (row) => {
    setSelected({
      ...row,
      estaActivo: row.estaActivo === 1, // 🔥 convertir a boolean para el checkbox
    });
    dispatchModal({ type: "SHOW_EDIT" });
  };

  /* ===== CERRAR ===== */
  const onClose = () => {
    dispatchModal({ type: "CLOSE" });
  };

  /* ===== HANDLE FORM ===== */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSelected((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  /* ===== GUARDAR ===== */
  const onGuardar = async () => {
    if (!selected.nombre || !selected.numeroInicio || !selected.numeroFinal) {
      Swal.fire("Atención", "Complete los campos obligatorios", "warning");
      return;
    }

    if (+selected.numeroFinal < +selected.numeroInicio) {
      Swal.fire(
        "Error",
        "El número final no puede ser menor al inicial",
        "error"
      );
      return;
    }

    try {
      await saveChequera({
        ...selected,
        estaActivo: selected.estaActivo ? 1 : 0, // 🔒 normalizar
        isNew: modal.showNew,
      });

      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "Chequera guardada correctamente",
        confirmButtonColor: "black",
      });

      dispatchModal({ type: "CLOSE" });
      onLoadChequeras();
    } catch (err) {
      Swal.fire("Error", `${err}`, "error");
    }
  };

  return (
    <Fragment>
      <Col lg={12}>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <Card.Title>Chequeras</Card.Title>
            <Button onClick={onAgregar}>Agregar</Button>
          </Card.Header>

          <Card.Body>
            <Table responsive>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>N° Inicio</th>
                  <th>N° Final</th>
                  <th>Banco</th>
                  <th>Cuenta</th>
                  <th>Activo</th>
                  <th>Opciones</th>
                </tr>
              </thead>
              <tbody>
                {listChequeras.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.nombre}</td>
                    <td>{item.numeroInicio}</td>
                    <td>{item.numeroFinal}</td>
                    <td>{item.banco}</td>
                    <td>{item.cuenta}</td>
                    <td>{item.estaActivo === 1 ? "Sí" : "No"}</td>
                    <td>
                      <Link
                        to="#"
                        className="btn btn-primary btn-xs"
                        onClick={() => onEditar(item)}
                      >
                        <i className="fas fa-pencil-alt" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>

      {/* ================= MODAL ================= */}
      <Modal show={modal.showNew || modal.showEdit} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modal.showNew ? "Nueva Chequera" : "Editar Chequera"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selected && (
            <Form>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Nombre *</Form.Label>
                    <Form.Control
                      name="nombre"
                      value={selected.nombre}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Número Inicio *</Form.Label>
                    <Form.Control
                      type="number"
                      name="numeroInicio"
                      value={selected.numeroInicio}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Número Final *</Form.Label>
                    <Form.Control
                      type="number"
                      name="numeroFinal"
                      value={selected.numeroFinal}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Banco</Form.Label>
                    <Form.Control
                      name="banco"
                      value={selected.banco}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Cuenta</Form.Label>
                    <Form.Control
                      name="cuenta"
                      value={selected.cuenta}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={12} className="mt-2">
                  <Form.Check
                    type="checkbox"
                    label="Activo"
                    name="estaActivo"
                    checked={!!selected.estaActivo}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={onGuardar}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default OCheques;
